import { useState } from 'react';
import Calendar from '@/components/calendar';
import Checkbox from '@/components/checkbox';
import Control from '@/components/control';
import { useContext } from '@/components/slider-type/context';
import { SliderSlice, selectAnswersDefaultByKey } from '@/redux/slider';
import Converter from '@/utils/converter';
import '@/components/slider-type/components/date-field/date-field-v1.css';
import '@/components/slider-type/components/date-field/date-field-v2.css';
import { useAppDispatch, useAppSelector } from '@/redux/store';
import { GeneralSlice } from '@/redux/general';
import { ConfigSlice } from '@/redux/config';

export default function DateField() {
  const { slide } = useContext();
  const {
    key = '',
    enableNotSureCheckbox = false,
    notSureValue = '',
    notSureLabel = '',
    calendarPeriod,
    calendarMode,
    calendarModalPosition,
    calendarPrecision,
  } = slide;
  const dispatch = useAppDispatch();
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const value = useAppSelector(selectAnswersDefaultByKey(key));
  const [isChecked, setIsChecked] = useState(false);

  const onCheckboxChange = () => {
    setIsChecked((prevState) => {
      if (!prevState) {
        dispatch(
          SliderSlice.actions.setAnswersDefaultByKey({
            key,
            value: notSureValue,
          }),
        );
      }
      return !prevState;
    });
  };

  return (
    <div data-css-version={cssVersion} className='date-field'>
      <Calendar
        name={key}
        startPosition={Converter.DateRelative.ToDate('today')}
        period={calendarPeriod}
        mode={calendarMode}
        modalPosition={calendarModalPosition}
        precision={calendarPrecision}
        value={value}
        onChange={(value, key) => dispatch(SliderSlice.actions.setAnswersDefaultByKey({ key, value }))}
        onOpen={(size) => dispatch(GeneralSlice.actions.setExtendedSliderHeight(size.height))}
        onClose={() => {
          dispatch(SliderSlice.actions.setValidationDirtyByKey(key));
          dispatch(GeneralSlice.actions.setExtendedSliderHeight(0));
        }}
        onBlur={() => dispatch(SliderSlice.actions.setValidationDirtyByKey(key))}
      />
      {enableNotSureCheckbox && (
        <div className='date-field__checkbox'>
          {cssVersion === 1 ? (
            <Checkbox value={isChecked} label={notSureLabel} name={key + '-checkbox'} onChange={onCheckboxChange} />
          ) : (
            <Control.Checkbox value={isChecked} id={key} onChange={onCheckboxChange}>
              <span className='date-field__checkbox-text'>{notSureLabel}</span>
            </Control.Checkbox>
          )}
        </div>
      )}
    </div>
  );
}
